export const usersStyles = {
  mainComponent: {
    height: '70vh',
  },
  emailText: { display: 'inline', fontWeight: '800' },
};
